import { z } from 'zod';

export const priceTierSchema = z.enum(['retail', 'wholesale']);
export type PriceTier = z.infer<typeof priceTierSchema>;

export const customerSchema = z.object({
  id: z.string(),
  authUserId: z.string().nullable(),
  email: z.string(),
  fullName: z.string().nullable(),
  phone: z.string().nullable(),
  priceTier: priceTierSchema,
  isActive: z.boolean(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
});
export type Customer = z.infer<typeof customerSchema>;
